var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CardHeader',{attrs:{"icon":_vm.icon1,"title":"个人标签","showFold":false}}),(_vm.show)?_c('div',{staticStyle:{"width":"100%","height":"200px"},attrs:{"id":"container"}}):_c('div',{staticStyle:{"padding-top":"24px"}},[_c('a-empty')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }